<script lang="ts">
    import RootPc from '../pc/Root.svelte';
    import RootSp from '../sp/Root.svelte';

    // -- Result of project ------------------
    const resultPkg = {
        amountSupporter:    341,
        amountDonatedMoney: 12518736,
        resultDate:         new Date("2023-10-01")
    }

    function isSmartPhone(){
        if(window.matchMedia && window.matchMedia('(max-device-width: 640px)').matches){
            return true;
        } else {
            return false;
        }
    }

    //-- Scroll to Support Activity -----------------------------------------
    function scrollIntoView({ target }){
        const el = document.querySelector(target.getAttribute('href'));
        if(!el) return;
        el.scrollIntoView({
            behavior: 'smooth'
        });
    }
</script>

{#if isSmartPhone()}
    <RootSp {...resultPkg}/>
{:else}
    <RootPc {...resultPkg}/>
{/if}

<style>

</style>